module.exports = __webpack_public_path__ + "static/media/mkomuniteti_logo.3888cc6b.svg";